export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Please enter a valid email address'
  },
  required: (v: any) => !!v || 'This field is required',
}

/** Human-readable message from axios / DRF-style error payloads */
export function apiErrorMessage(e: unknown, fallback = 'Something went wrong'): string {
  const ax = e as { response?: { data?: unknown }; message?: string }
  const data = ax?.response?.data
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>
    if (typeof o.detail === 'string') return o.detail
    if (Array.isArray(o.detail)) return o.detail.map(String).join(' ')
    if (Array.isArray(o.non_field_errors)) return (o.non_field_errors as string[]).join(' ')
    for (const v of Object.values(o)) {
      if (Array.isArray(v) && v.length && v.every((x) => typeof x === 'string')) return (v as string[]).join(' ')
    }
  }
  return ax?.message || fallback
}
